import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Reasta

  <span style="color:#85c1dc;">**FI:**</span>
  Lajittele

  <span style="color:#85c1dc;">**RU:**</span>
  Сортировать
*/
/* @__NO_SIDE_EFFECTS__ */
const m2011 = msg(
  mf`Reasta`,
  mf`Lajittele`,
  mf`Сортировать`,
)

export { m2011 as 'w.module.filter_bar.order_by' }